import type { SVGProps } from "react";

/**
 * Oven — a standalone oven silhouette with door and handle.
 */
export function OvenIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {/* Oven body */}
      <rect
        x={4}
        y={6}
        width={40}
        height={36}
        rx={3}
        fill="currentColor"
        opacity={0.1}
      />
      <rect
        x={4}
        y={6}
        width={40}
        height={36}
        rx={3}
        stroke="currentColor"
        strokeWidth={1.5}
        opacity={0.35}
        fill="none"
      />
      {/* Door */}
      <rect
        x={8}
        y={12}
        width={32}
        height={26}
        rx={2}
        fill="currentColor"
        opacity={0.08}
      />
      {/* Door handle */}
      <rect
        x={16}
        y={10}
        width={16}
        height={3}
        rx={1.5}
        fill="currentColor"
        opacity={0.5}
      />
      {/* Racks */}
      <line
        x1={10}
        y1={20}
        x2={38}
        y2={20}
        stroke="currentColor"
        strokeWidth={0.8}
        opacity={0.2}
      />
      <line
        x1={10}
        y1={28}
        x2={38}
        y2={28}
        stroke="currentColor"
        strokeWidth={0.8}
        opacity={0.2}
      />
      {/* Control knobs */}
      <circle cx={12} cy={42} r={2} fill="currentColor" opacity={0.35} />
      <circle cx={20} cy={42} r={2} fill="currentColor" opacity={0.35} />
      <circle cx={28} cy={42} r={2} fill="currentColor" opacity={0.35} />
      <circle cx={36} cy={42} r={2} fill="currentColor" opacity={0.35} />
    </svg>
  );
}
